import { render, staticRenderFns } from "./UserSettingReportHangkong.vue?vue&type=template&id=44a34232&scoped=true&"
import script from "./UserSettingReportHangkong.vue?vue&type=script&lang=js&"
export * from "./UserSettingReportHangkong.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingReportHangkong.vue?vue&type=style&index=0&id=44a34232&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a34232",
  null
  
)

export default component.exports